import SupplierStatusCell from '@/components/suppliers/SupplierStatusCell';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { ColumnDef } from '@tanstack/react-table';
import { SupplierStatus } from '../suppliers/SupplierStatus';
import { format } from 'date-fns';
import { Translator } from '../translator.type';

export type CircuitUsedByBenefit = {
  id: string;
  name: string;
  code: string;
  status: SupplierStatus;
  updatedAt: string;
};

export type BenefitUsageResponse = {
  circuits: CircuitUsedByBenefit[];
  hotels: HotelUsedByBenefit[];
};

export type HotelUsedByBenefit = {
  id: string;
  benefitId: string;
  benefit: {
    id: string;
    name: string;
    code: string;
  };
};

export const CIRCUITS_USED_BY_BENEFIT_COLUMN_DEF = (
  t: Translator,
): ColumnDef<CircuitUsedByBenefit>[] => [
  {
    accessorKey: 'code',
    header: t('benefits.circuits.columns.code'),
    cell: ({ row }) =>
      row.original.code && (
        <span>{`C${row.original.code.toString().padStart(4, '0')}`}</span>
      ),
  },
  {
    accessorKey: 'name',
    header: t('benefits.circuits.columns.name'),
    cell: ({ row }) => (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            className="max-w-72 xl:max-w-96 inline-block overflow-hidden whitespace-nowrap text-ellipsis"
            aria-label="nom"
          >
            {row.original.name}
          </TooltipTrigger>
          <TooltipContent
            className="bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-lg"
            aria-label="nom complet"
          >
            {row.original.name}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ),
  },
  {
    accessorKey: 'updatedAt',
    header: t('benefits.circuits.columns.updatedAt'),
    cell: ({ row }) => (
      <span>{format(new Date(row.original.updatedAt), 'dd/MM/yyyy')}</span>
    ),
  },
  {
    accessorKey: 'status',
    header: t('benefits.circuits.columns.status'),
    cell: ({ row }) => <SupplierStatusCell status={row.original.status} />,
  },
];

export const HOTELS_USED_BY_BENEFIT_COLUMN_DEF = (
  t: Translator,
): ColumnDef<HotelUsedByBenefit>[] => [
  {
    accessorKey: 'benefit.code',
    id: 'code',
    header: t('benefits.circuits.columns.code'),
    cell: ({ row }) =>
      row.original.benefit?.code != null && (
        <span>{`P${row.original.benefit.code.toString().padStart(4, '0')}`}</span>
      ),
  },
  {
    accessorKey: 'benefit.name',
    id: 'name',
    header: t('benefits.circuits.columns.name'),
    cell: ({ row }) => (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            className="max-w-72 xl:max-w-96 inline-block overflow-hidden whitespace-nowrap text-ellipsis"
            aria-label="nom"
          >
            {row.original.benefit?.name ?? '-'}
          </TooltipTrigger>
          <TooltipContent
            className="bg-gray-800 text-white text-sm px-2 py-1 rounded shadow-lg"
            aria-label="nom complet"
          >
            {row.original.benefit?.name ?? '-'}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    ),
  },
];
